import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutOtherChargeChangeCompareItem extends Layout {
    sourceEdiCompareItem: DataSource;
    tableChangeCompareItems: Table;
}
